module.exports = __webpack_public_path__ + "img/icon (15).7733c2a2.png";